<template>
  <site-banner pagina="clinicas" />

  <div class="container-fluid">
    <div class="row clinica-faixa">
      <div class="col centralizar">
        <h2>{{ $t("Agende a sua avaliação em") + " " + clinica.nome }}</h2>
        <div v-if="clinica.whatsappblip">
          <NuxtLink
            class="botao"
            :to="`https://api.whatsapp.com/send?phone=${
              clinica.whatsappblip
            }&text=${t('TextoWhatsappAgendamento')}`"
          >
            {{ $t("Agendar agora") }}
          </NuxtLink>
        </div>
        <div v-else>
          <!-- <NuxtLink class="botao" to="#formulario-agenda">
            {{ $t("Agendar agora") }}
          </NuxtLink> -->
        </div>
      </div>
    </div>

    <div class="row clinica-detalhe">
      <div class="col-md-6 clinica-detalhe-lista">
        <h2>{{ clinica.nome }}</h2>

        <div v-if="clinica.whatsapp" class="row mb-4">
          <div class="col-2">
            <img src="/whatsapp.svg" class="midia" alt="Whatsapp" />
          </div>
          <div class="col-10">
            <a>{{ clinica.whatsapp }}</a>
          </div>
        </div>

        <div v-if="clinica.telefone" class="row mb-4">
          <div class="col-2">
            <img src="/telephone.svg" class="midia" alt="Telefone" />
          </div>
          <div class="col-10">
            <a>{{ clinica.telefone }}</a>
          </div>
        </div>

        <div v-if="clinica.endereco" class="row mb-4">
          <div class="col-2 pt-2">
            <img src="/geopin.svg" class="midia" alt="Localização" />
          </div>
          <div class="col-10">
            <a>{{ clinica.endereco }}, {{ clinica.numero }}</a>
            <a>{{ clinica.bairro }} - {{ clinica.cep }}</a>
            <a>{{ clinica.cidade }} - {{ clinica.estado }}</a>
          </div>
        </div>

        <div v-if="clinica.horario" class="row mb-4">
          <div class="col-2 pt-2">
            <img src="/clock.svg" class="midia" alt="Horários" />
          </div>
          <div class="col-10">
            <a>{{ clinica.horario }}</a>
          </div>
        </div>

        <div v-if="clinica.responsavel" class="row mb-5">
          <div class="col-2 pt-2">
            <img src="/person.svg" class="midia" alt="RT" />
          </div>
          <div class="col-10">
            <a>RT {{ clinica.responsavel }}</a>
            <a v-if="clinica.cro">CRO {{ clinica.cro }} </a>
            <a v-if="clinica.epao">EPAO {{ clinica.epao }}</a>
          </div>
        </div>
      </div>

      <div class="col-md-6 clinica-detalhe-mapa">
        <iframe
          :title="'Mapa da clínica' + clinica.nome"
          :src="clinica.mapa"
        ></iframe>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-5">
        <!-- <div v-if="!clinica.whatsappblip">
          <div v-if="locale == 'pt'">
            <formulario-agenda-brasil
              id="formulario-agenda"
              :clinica="clinica.nome"
              :codigo="clinica.codigo"
            />
          </div>
          <div v-if="locale == 'es'">
            <formulario-agenda-uruguai
              id="formulario-agenda"
              :clinica="clinica.nome"
              :codigo="clinica.codigo"
            />
          </div>
        </div> -->

        <!-- <site-indique :slug="clinica.slug" /> -->
      </div>
      <div class="col-md-7">
        <h2 class="mb-3">{{ $t("Conheça a clínica") }}</h2>
        <p class="mx-5">{{ clinica.descricao }}</p>

        <div id="clinica-imagem-lista" class="clinica-imagem-lista">
          <custom-lista
            v-if="!carregando"
            :itens="imagensRef"
            colunas="2"
            width="300"
            height="auto"
          />
        </div>
      </div>
    </div>
  </div>

  <site-tratamentos />

  <div class="clinica-informacao-lista">
    <site-informacoes />
  </div>

  <custom-whatsapp-button
    v-if="clinica.whatsappblip"
    :telefone="clinica.whatsappblip"
    :texto="t('TextoWhatsapp')"
  />
</template>

<script setup>
definePageMeta({
  layout: "clinica",
});

const { t, locale } = useI18n();
const carregando = ref(true);
const { slug } = useRoute().params;
const imagensRef = ref([]);
const { data: clinica } = await useFetch(`/api/site/clinicas/${slug}`);

onMounted(() => {
  if (clinica?.value?.imagens?.length > 0) {
    Object.values(clinica.value.imagens).forEach((clinica) => {
      imagensRef.value.push({
        imagem: clinica?.imagem,
      });
    });
  }
  carregando.value = false;
});

useSeoMeta({
  title: `${t("sorrifacil")} ${clinica.value.nome} ${t("na cidade de")} ${
    clinica.value.cidade
  }`,
  ogTitle: `${t("sorrifacil")} ${clinica.value.nome} ${t("na cidade de")} ${
    clinica.value.cidade
  }`,
  description: `${t("Somos a")} ${t("sorrifacil")} ${clinica.value.nome} ${t(
    "na cidade de"
  )} ${clinica.value.cidade}/${clinica.value.estado}`,
  ogDescription: `Somos a ${t("sorrifacil")} ${clinica.value.nome} ${t(
    "na cidade de"
  )} ${clinica.value.cidade}/${clinica.value.estado}`,
});
</script>

<script>
export default {
  name: "ClinicaPagina",
};
defineI18nRoute({
  paths: {
    pt: "/clinicas/[slug]",
    es: "/clinicas/[slug]",
  },
});
</script>
